module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-formL-8997eda15ae1189e48357d798dd6ca93.png";